export default {
  name: "Vehicle Check (GPM)",
  description: "Standard vehicle check for GPM department vehicles.",
  required: ["Name", "LicensePlate", "Mileage"],
  fields: [
    { key: "Name", label: "Name", type: "text", required: true },
    { key: "Date", label: "Date", type: "date" },
    { key: "Department", label: "Department", type: "text" },
    { key: "LicensePlate", label: "Vehicle Number Plate", type: "text", required: true },
    { key: "Mileage", label: "Mileage", type: "number", required: true },
    { key: "Cleanliness", label: "Cleanliness of Vehicle", type: "text" },
    { key: "Damage", label: "Any Visible Damage", type: "text" },
    { key: "Notes", label: "Additional Notes", type: "textarea" }
  ],
  photos: true
};
